import { useState } from "react";
import { X, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { money } from "@/lib/format";

export default function RefundModal({ sale, onClose, onDone }) {
  const [amount, setAmount] = useState(sale.total);
  const [method, setMethod] = useState("store_credit");
  const [reason, setReason] = useState("");
  const [restock, setRestock] = useState(true);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!(Number(amount) > 0)) { toast.error("Enter a refund amount greater than 0"); return; }
    setLoading(true);
    try {
      const { data } = await api.post(`/pos/sales/${sale.id}/refund`, {
        amount: Number(amount), method, reason, restock,
      });
      toast.success(`Refund processed (${data.new_status})${data.gift_card_code ? ` — gift card ${data.gift_card_code}` : ""}`);
      onDone();
      onClose();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] grid place-items-center px-4 bg-black/40 backdrop-blur-sm" data-testid="refund-modal">
      <div className="relative w-full max-w-md bg-[#F9F7F3] rounded-3xl shadow-2xl p-8">
        <button onClick={onClose} className="absolute top-4 right-4 text-[#4A5D6B]"><X size={20} /></button>
        <h3 className="font-serif text-2xl text-[#1A242B] mb-1">Refund sale</h3>
        <p className="text-sm text-[#4A5D6B] mb-5">{sale.client_name || "Walk-in"} · {money(Number(sale.total || 0))}</p>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-[#4A5D6B]">Amount ($)</label>
            <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="refund-amount" className="eyw-input w-full" />
          </div>
          <div>
            <label className="text-xs text-[#4A5D6B]">Method</label>
            <select value={method} onChange={(e) => setMethod(e.target.value)} data-testid="refund-method" className="eyw-input w-full">
              <option value="store_credit">Store credit (to client)</option>
              <option value="gift_card">New gift card</option>
              <option value="original">Original method (card/cash)</option>
              <option value="cash">Cash</option>
            </select>
          </div>
          <input placeholder="Reason" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="refund-reason" className="eyw-input w-full" />
          <label className="flex items-center gap-2 text-sm text-[#4A5D6B]"><input type="checkbox" checked={restock} onChange={(e) => setRestock(e.target.checked)} data-testid="refund-restock" /> Restock returned products</label>
          {method === "original" && <p className="text-xs text-[#B5794E]">Card refunds must also be issued in your Stripe dashboard.</p>}
        </div>
        <button onClick={submit} disabled={loading} data-testid="refund-submit" className="eyw-btn w-full mt-5 disabled:opacity-60">
          {loading && <Loader2 className="animate-spin" size={18} />} Process refund
        </button>
      </div>
    </div>
  );
}
